import { Icon, Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { useResponsive } from "src/utils/useResponsive"

interface FileUploadLabelProps {
  maxFileSize: string
  fileFormats: string
  isDragOver: boolean
}

const FileUploadLabel = ({ maxFileSize, fileFormats, isDragOver }: FileUploadLabelProps) => {
  const { t } = useTranslation("filesUpload")
  const { isMobile } = useResponsive()

  if (isMobile) {
    return (
      <Icon
        className="material-symbols-outlined"
        sx={{
          color: isDragOver ? "#CBF5FF" : "#E7E7E7",
          fontSize: "150px",
          fontVariationSettings: "'FILL' 0, 'wght' 200, 'GRAD' 0, 'opsz' 24"
        }}
      >
        backup
      </Icon>
    )
  }

  return (
    <Stack spacing={1} alignItems={"center"}>
      <Typography variant="h4">{t(isMobile ? "dragOrUploadMobile" : "dragOrUpload")}</Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        {t("supportedFormats")}:<br /> {fileFormats}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-line", textAlign: "center" }}>
        {t("sizeLimit")}: {maxFileSize}
      </Typography>
    </Stack>
  )
}

export default FileUploadLabel
